/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import L from "../Lang"
import BaseCom from "../BaseCom";
import DataTable from "../DataTable";
import Icon from "../Icon";
import { SidebarGlobal } from "../_SidebarGlobal";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

import CompendiumTabs from "./CompendiumTabs";
import React from "react";
import { qreq } from "../../shared/qrequest";
import Auth from "../../shared/Auth";

class PanelManageList extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: [], search: "", status: "all"
        };
        this.fileRef = React.createRef();
    }

    async componentDidMount() {
        await this.getSettings();
        SidebarGlobal.setSubNav(<>
            <button className="btn btn-primary" onClick={() => this.props.navigate('/panel/manage/new')}><Icon icon="faPlus" /> <span className="d-none d-md-inline"><L>New Panel</L></span></button>
            {Auth.hasPolicy('master') && <button className="btn btn-warning" onClick={this.triggerImport}><Icon icon="faFileUpload" /> <span className="d-none d-md-inline"><L>Import</L></span></button>}
        </>);
        this.load();
    }

    load = () => {
        this.fillList('/api/panel/list', 'list');
    }

    triggerImport = () => {
        this.fileRef.current.click();
    }

    import = async (e) => {
        this.setState({ uploading: true });
        try {
            let file = e.target.files[0];
            let formData = new FormData();
            formData.append('file', file);
            let j = await qreq.postformAsync('/api/panel/import', formData);
            if (j.errorCode === 0) {
                this.success(`Inserted ${j.item.insertedPanels} panels, ${j.item.insertedTargets} targets, and ${j.item.insertedSpecimens} specimens.`);
                this.load();
            }
            else {
                this.alert(j.errorMessage);
            }
        }
        catch (e) {
            this.unkownErrorCallback();
        }
        e.target.value = null;
        this.setState({ uploading: false });
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    search = (e) => {
        this.setState({ search: e.target.value });
    }

    list = () => {
        const query = this.state.search.trim().toLowerCase();
        const list = (this.state.list ?? []).filter(row =>
            (this.state.status === 'all' || (this.state.status === 'disabled' ? !!row.isDisabled : !row.isDisabled)) &&
            (!query || ['name', 'code', 'shortName', 'productLineName', 'specimenTypeName'].some(field => String(row[field] ?? '').toLowerCase().includes(query)))
        );

        return list;
    }

    onSort = () => {

    }

    render() {
        const columns = [
            { name: 'edit', title: '', valueFunc: (row) => <Link to={`/panel/manage/${row.id}`} title="Edit" aria-label={`Edit ${row.name || row.code}`} className="text-primary"><Icon icon="faPencil" /></Link>, width: '25px' },


            { name: 'code', title: 'Code', valueFunc: (row) => <Link to={`/panel/manage/${row.id}`} title="Edit">{row.code}</Link>, width: '150px' },
            { name: 'name', title: 'Name', valueFunc: (row) => <Link to={`/panel/manage/${row.id}`} title="Edit">{row.name}</Link> },
            { name: 'specimenTypeName', title: 'Specimen Type' },
            { name: 'productLineName', title: 'Product Line' },
            { name: 'active', title: 'Status', valueFunc: (row) => <span className={'badge ' + (row.isDisabled ? 'bg-secondary' : 'bg-success')}><L>{row.isDisabled ? 'Disabled' : 'Active'}</L></span> }
        ];


        return <div className="container-fluid vh-expand u-page">
            <CompendiumTabs />
            <header className="u-header">
                <h1 role="heading" aria-level="1"><L>Manage Panels</L></h1>
                <div className="u-eyebrow"><Link to="/lab/manager"><L>Lab Management</L></Link></div>
                <p className="u-intro"><L>Configure laboratory test panels.</L></p>
            </header>
            <input type="file" ref={this.fileRef} className="d-none" onChange={this.import} />
            <div className="card border-0 shadow-sm mb-3">
                <div className="card-body d-flex flex-wrap align-items-center gap-3">
                    <div className="input-group flex-grow-1" style={{ flexBasis: '260px' }}>
                        <span className="input-group-text"><Icon icon="faSearch" /></span>
                        <input type="search" className="form-control" aria-label="Search panels"
                            placeholder="Search panels by name or code..." value={this.state.search} onChange={this.search} />
                        {this.state.search && <button type="button" className="btn btn-outline-secondary" onClick={() => this.setState({ search: '' })}><L>Clear</L></button>}
                    </div>
                    <select className="form-select w-auto" aria-label="Filter by status" value={this.state.status} onChange={e => this.setState({ status: e.target.value })}>
                        <option value="all">All statuses</option><option value="active">Active</option><option value="disabled">Disabled</option>
                    </select>
                    <span className="text-body-secondary small" role="status">{this.list().length} / {(this.state.list ?? []).length} <L>panels</L></span>
                </div>
            </div>
            {!this.state.loading && this.list().length === 0 && <div className="alert alert-light border" role="status"><L>No panels found. Try a different search or status.</L></div>}
            <DataTable columns={columns} data={this.list()} totalCount={this.state.totalCount} headClassName="--bg-primary" loading={this.state.loading} onSort={this.onSort}
                showCheckboxes={this.state.showFilters} defaultSort="name" defaultSortDesc />

        </div>;
    }
}

export default withParamsAndNavigate(PanelManageList);